export default __webpack_public_path__ + "static/media/banner.3a7b9951.mp4";